import React from 'react';
import { Modal, Message } from 'htlib-copy';

import { func, arrayOf, string } from 'prop-types';

import './MissingEntitiesModal.scss';

export default function MissingEntitiesModal({ onClose, missingEntities }) {
  return (
    <Modal
      onClose={() => {
        onClose(false);
      }}
    >
      <div className="MissingEntitiesModal">
        <h3 className="MissingEntitiesModal__title">Caution! Missing entities in thesaurus</h3>
        <Message type="warn">
          <p>Warning! The following entities were not found in the thesaurus:</p>
        </Message>

        <ul className="MissingEntitiesModal__list">
          {missingEntities.map(entityId => (
            <li key={entityId}>{entityId}</li>
          ))}
        </ul>
      </div>
    </Modal>
  );
}

MissingEntitiesModal.propTypes = {
  missingEntities: arrayOf(string).isRequired,
  onClose: func.isRequired,
};
